import React, { useMemo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import { buildToDestination, mergeSharedSearchParamKeysWithDefault } from '@app/utils/navigation'

import type { ExtendedLinkProps } from './types'

export const ExtendedLink: React.FC<ExtendedLinkProps> = ({
  children,
  sharedSearchParamKeys: outerSharedSearchParamKeys,
  to,
  ...props
}) => {
  const [searchParams] = useSearchParams()

  const sharedSearchParams = useMemo(
    () => mergeSharedSearchParamKeysWithDefault(outerSharedSearchParamKeys),
    [outerSharedSearchParamKeys]
  )

  const builtTo = useMemo(() => buildToDestination(to, searchParams, sharedSearchParams), [to, sharedSearchParams])

  return (
    <Link
      { ...props }
      to={ builtTo }
    >
      { children }
    </Link>
  )
}
